import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  empresa: {
    alignSelf: 'center',
    fontSize: '1rem',
    fontWeight: 500,
    marginBottom: '10px',
    fontFamily: 'serif',
  },
  tituloProdutos: {
    alignSelf: 'center',
    fontSize: '1.5rem',
    fontWeight: 600,
    marginTop: '10px',
    fontFamily: 'serif',
  },
  texto: {
    fontSize: '.95rem',
    fontFamily: 'serif',
  },
  productText: {
    fontSize: '1rem',
    fontFamily: 'serif',
    fontWeight: 'bold',
  },
  clienteInfo: {
    fontSize: '.95rem',
    fontFamily: 'serif',
  },
  nomeComplemento: {
    fontSize: '.9rem',
    fontWeight: 500,
    fontFamily: 'serif',
  },
  precoComplemento: {
    minWidth: 'max-content',
    fontSize: '.9rem',
    fontFamily: 'serif',
  },
  totalItem: {
    minWidth: 'max-content',
    fontSize: '.9rem',
    fontFamily: 'serif',
  },
  divider: {
    width: '100%',
    backgroundColor: 'black',
    margin: '10px 0px 10px 0px',
    fontFamily: 'serif',
  },
}));
